import { IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { primary } from '@/theme/colors';

export const OutlinedIconButton = muiStyled(IconButton)({
  border: '2px solid #fff',
  // border: '2px solid',
  // borderColor: primary.dark,
  color: primary.dark,
  borderRadius: '4px',
  padding: '4px',
  marginLeft: '10px',
});
